<template>
  <div class="relation-tabs">
    <div class="switcher gf-row">
      <div class="col-12">
        <div class="relation-switch">
          <ul>
            <template v-for="target in targets">
              <li class="switch-value" :class="{active: currentTarget?.[relField]?.uuid==target.uuid}" v-on:click.prevent="select(target)">
                <a href="" v-on:click.prevent="">
                  {{ target.title || target.name }}
                  <span v-if="hasTarget(target.uuid)" href="" v-on:click.prevent.stop="removeTarget(target.uuid)" class="remove">&times;</span>
                  <span v-else href="" class="add">+</span>
                </a>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <template v-if="currentTarget">
    <DataForm v-if="dbfield?.cascade=='delete'" :params="{type}" :item="currentTarget" :key="'editForm'+currentTarget[relField].uuid" />
  </template>
</template>

<script>
import api from '@/Util/api';
export default {
  props: ["modelValue", "field", "item", "field", "dbfield", "relField"],
  data: ()=>({
    value: [],
    targets: [],
    currentTarget: null,
  }),
  watch: {
    value: {
      handler() {
        this.$emit("update:modelValue", this.value);
      }, deep: true,
    },
    modelValue: {
      handler() {
        this.value=this.modelValue || [];
      }, immediate: true, deep: true,
    },
    typeTargetRelField: {
      async handler() {
        this.targets=[];
        if (this.typeTargetRelField?.target) {
          this.targets=await api.list(this.typeTargetRelField?.target, null, "{id,uuid,title,name,featuredOrder}");
          this.targets.sort((a,b)=>(a.featuredOrder || 0)-(b.featuredOrder || 0));
        }
      }, immediate: true,
    },
  },
  computed: {
    type() {
      return this.dbfield?.target;
    },
    typeTargetRelField() {
      return this.fieldDesc[this.relField];
    },
    fieldDesc() {
      return this.stores.auth.typeDesc?.[this.type] ?? {};
    },
  },
  methods: {
    hasTarget(uuid) {
      return !!this.value.find(item=>item[this.relField]?.uuid == uuid);
    },
    addTarget(target) {
      var newItem={};
      for(var field in this.fieldDesc) {
        if (field!=this.dbfield.name)
          newItem[field]=null;
        if (field==this.relField)
          newItem[field]=target;
      }
      this.value.push(newItem);
      this.currentTarget=newItem;
    },
    removeTarget(uuid) {
      var targetIndex=this.value.findIndex(item=>item[this.relField]?.uuid == uuid);
      if (targetIndex!=-1);
        this.value.splice(targetIndex, 1);
      this.currentTarget=null;
    },
    select(target) {
      this.currentTarget=this.value.find(item=>item[this.relField]?.uuid == target.uuid);
      if (!this.currentTarget) {
        this.addTarget(target);
        this.$nextTick(()=>{
          this.currentTarget=this.value.find(item=>item[this.relField]?.uuid == target.uuid);
        });
      }
    },

  },
}
</script>
